<template>
  <div class="bg-gray-900 rounded-lg p-4 mt-4">
    <table
      class="table-auto text-white w-full divide-y divide-gray-400"
      v-if="this.tableData.length"
    >
      <tr>
        <th class="text-right py-2">نام سازمان</th>
        <th class="text-left">مقدار</th>
        <th class="text-left">مبلغ</th>
      </tr>
      <tr v-for="organ in tableData" :key="organ">
        <th class="text-xs text-right py-3">{{ organ.name }}</th>
        <td class="text-left text-sm">
          {{ this.$helper.priceFormatter(organ.qty, false) }}
        </td>
        <td class="text-left text-sm">
          {{ this.$helper.priceFormatter(organ.mab, false) }}
        </td>
      </tr>
    </table>
    <h6 class="my-8 text-gray-600 text-center" v-else>بدون داده</h6>
  </div>
</template>

<script>
import { getCountByOrganization } from "../../API/API";

export default {
  name: "OrganizationTreemap",
  props: ["month", "day"],
  data() {
    return {
      tableData: [],
      options: {
        fontFamily: "iransans",
        colors: ["#ef4444"],
        dataLabels: {
          enabled: true,
          style: {
            colors: ["#fff", "#eee", "#aaa"],
          },
        },
        tooltip: {
          theme: "dark",
        },
      },
      series: [
        {
          data: [],
        },
      ],
    };
  },
  created() {
    this.getReports();
  },
  methods: {
    getReports() {
      this.series = [{ data: [] }];
      this.tableData = [];
      getCountByOrganization("month", "", "", this.month, this.day).then(
        (resp) => {
          resp.data.result.yaxis.forEach((item, index, yaxis) => {
            // Only Quantity Values for the Treemap Chart
            if (item.numberType === "qty") {
              this.series[0].data.push({
                x: item.name,
                y: item.data[0],
              });
            }

            // Merge Quantity and Price into single array for table
            if (
              index + 1 < yaxis.length &&
              item.name === yaxis[index + 1].name
            ) {
              this.tableData.push({
                name: item.name,
                mab: item.data[0],
                qty: yaxis[index + 1].data[0],
              });
            }
          });
        }
      );
    },
  },
  watch: {
    day() {
      if (this.day !== "") this.getReports();
    },
    month() {
      this.getReports();
    },
  },
};
</script>

<style scoped></style>
